import { render, staticRenderFns } from "./PessoasAtendidas.vue?vue&type=template&id=d5de9c0e"
import script from "./PessoasAtendidas.vue?vue&type=script&lang=js"
export * from "./PessoasAtendidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports